module.exports = __webpack_public_path__ + "static/media/linkedinpic.69ddb349.jpg";